export default {
    profile: 'Perfil',
    home:'Principal',
    about_us:'Sobre nosotros',
    booking_history:'Historial de reservas',
    logout:'Cerrar sesión',
    notification_title:'Notificación Servicio de Taxi',
    select_reason:'Seleccionar motivo de cancelación',
    no_cancel_reason:'No hay razones de cancelación disponibles.',
    ok:'Ok',
    cancel:'Cancelar',
    select_country:'Elige un pais',
    google_places_error:'Identificación del lugar al error de ubicación',
    not_valid_rider:'Este inicio de sesión es un usuario válido pero no Pasajero',
    new_booking_msg:'Tiene una nueva solicitud de reserva',
    no_driver:'No se encontró conductor',
    no_bookings:'No hay reservas disponibles.',
    booking_cancelled:'Se cancela la reserva. ID: ',
    no_cars:'No hay autos disponibles.',
    no_route:'No se encontró ruta.',
    firstname:'Nombre',
    lastname:'Apellido',
    email:'Email',
    phone:'Número de teléfono',
    password:'Contraseña',
    otp:'OTP',
    profile_updated:'Perfil actualizado.',
    proper_email:'Por favor ingrese el correo electrónico correctamente.',
    submit:'Enviar',
    booking_title:'Mis reservas',
    booking_id:'ID de reserva',
    booking_date: 'Fecha de reservación',
    car_type: 'Tipo de carro',
    pickup_address :'Dirección de Recojo',
    drop_address: 'Dirección de entrega',
    booking_status: 'Estado de la reservación',
    trip_cost:'Costo del viaje',
    payment_status:'Estado de pago',
    cancel_booking:'Cancelar reserva',
    select_car:'Seleccione tipo de auto',
    select_booking_type:'Seleccione tipo de reserva',
    book_now: 'Reservar ahora',
    book_later: 'Reserve más tarde',
    book: 'Reserva',
    select_proper:'Por favor seleccione correctamente.',
    must_login:'Por favor, inicie sesión para reservar',
    pickup_location:'Lugar de recogida',
    drop_location:'Lugar de llegada',
    booking_success:'Reserva exitosa. ID de reserva: ',
    myaccount: 'Mi cuenta',
    login_signup: 'Iniciar sesión Registrarse',
    login_success:'Acceso exitoso. Necesito completar el registro.',
    login_validate_error:'El correo electrónico o la contraseña no son correctos.',
    otp_validate_error:'OTP no es válido',
    reset_pass_msg:'Restablecer el enlace de contraseña enviado al correo electrónico.',
    signin:'Registrarse',
    login:'Iniciar sesión',
    register:'Registrarse',
    get_otp:'Obtén OTP',
    verify_otp:'Verificar OTP',
    complete_registration:'Registro completo',
    forgot_pass_title:'Olvidó tu contraseña',
    forgot_pass_description:'Complete su dirección de correo electrónico y solicite. El enlace se enviará a su bandeja de entrada de correo electrónico.',
    reset_password:'Restablecer la contraseña',
    email_tab:'Email Login',
    phone_tab:'Telefono Login',
    booking_date_time:'Datos de tiempo de reserva',
    past_booking_error:'Ride Later no está disponible para Fecha Pasada o dentro de los próximos 15 minutos.',
    booking_taken:'Se toma la reserva. El conductor será asignado dentro de los 15 minutos antes de su hora de reserva. Su identificación de reserva es: ',
    settings_error: 'No se puede sincronizar la configuración.',
    estimate:'Estimación de tarifa',
    auth_error:'Alerta de autenticación',
    email_verify_message:'Por favor verifique su correo electrónico. El correo electrónico ya se envió a su bandeja de entrada.'
}